import AccordionComponent from "components/Accordion"
import AudioComponent from "components/Audio"
import AuthorBox from "components/AuthorBox"
import BlockQuotes from "components/BlockQuotes"
import ContactForm from "components/ContactForm"
import Cta from "components/Cta"
import { DesignPortfolioAdapter } from "components/DesignPortfolio"
import DividerHeadline from "components/DividerHeadline"
import Facts from "components/Facts"
import HomeHero from "components/HomeHero"
import ImageGrid from "components/ImageGrid"
import ImagesSection from "components/ImagesSection"
import Jobs from "components/Jobs"
import LatestEdit from "components/LatestEdit"
import LinkBox from "components/LinkBox"
import LinkList from "components/LinkList"
import List from "components/List"
import MatomoOptOut from "components/MatomoOptOut"
import Partners from "components/Partners"
import PriceSlider from "components/PriceSlider"
import ReferencesSlider from "components/ReferencesSlider"
import { TableComponent } from "components/TableComponent"
import Team from "components/Team"
import TeaserLinks from "components/TeaserLinks"
import TextImage from "components/TextMedia/TextImage"
import TextVideo from "components/TextMedia/TextVideo"
import Tools from "components/Tools"
import Wysiwyg from "components/Wysiwyg"
import hljs from "highlight.js/lib/core"
import "highlight.js/styles/atom-one-light.css"
import { useEffect } from "react"
import { getColors } from "utils/color-combinations"

// You have to define and register the specific languages here, because auto-detection doesn't work correctly.
const hljsLanguages = ["css", "scss", "javascript", "xml"]
hljs.registerLanguage("css", require("highlight.js/lib/languages/css"))
hljs.registerLanguage("scss", require("highlight.js/lib/languages/scss"))
hljs.registerLanguage(
  "javascript",
  require("highlight.js/lib/languages/javascript")
)
hljs.registerLanguage("xml", require("highlight.js/lib/languages/xml"))

hljs.configure({
  languages: hljsLanguages,
})

const DynamicContent = ({ content, references }) => {
  const singlePageContent = Array.isArray(content)
    ? content.length === 1
      ? content[0]
      : null
    : content

  // ContentTypes
  const contentTypes = {
    Set_DynamicContent_Wysiwyg: Wysiwyg,
    Set_DynamicContent_Quotes: BlockQuotes,
    Set_DynamicContent_Images: ImagesSection,
    Set_DynamicContent_List: List,
    Set_DynamicContent_Facts: Facts,
    Set_DynamicContent_DividerHeadline: DividerHeadline,
    Set_DynamicContent_TextImage: TextImage,
    Set_DynamicContent_Accordion: AccordionComponent,
    Set_DynamicContent_LinkList: LinkList,
    Set_DynamicContent_Tools: Tools,
    Set_DynamicContent_Partners: Partners,
    Set_DynamicContent_HomeHero: HomeHero,
    Set_DynamicContent_DesignPortfolio: DesignPortfolioAdapter,
    Set_DynamicContent_TableComponent: TableComponent,
    Set_DynamicContent_PriceSlider: PriceSlider,
    Set_DynamicContent_ImageGrid: ImageGrid,
    Set_DynamicContent_Referencesslider: ReferencesSlider,
    Set_DynamicContent_TeaserLinks: TeaserLinks,
    Set_DynamicContent_TextVideo: TextVideo,
    Set_DynamicContent_Audio: AudioComponent,
    Set_DynamicContent_LatestEdit: LatestEdit,
    Set_DynamicContent_ContactForm: ContactForm,
    Set_DynamicContent_Linkbox: LinkBox,
    Set_DynamicContent_Authorbox: AuthorBox,
    Set_DynamicContent_MatomoOptOut: MatomoOptOut,
    Set_DynamicContent_Team: Team,
    Set_DynamicContent_Cta: Cta,
    Set_DynamicContent_Jobs: Jobs,
  }

  const dynamicContent = singlePageContent?.dynamic_content || []

  useEffect(() => {
    document.querySelectorAll("pre code").forEach((el) => {
      hljs.highlightElement(el)
    })
  }, [])

  return (
    <>
      {/* Dynamic singlePageContent sections */}
      {dynamicContent.map((item, i) => {
        const Component = contentTypes[item.__typename]

        if (!Component) return null

        // item, page, or default colors
        const colorData = {
          theme_colors_combinations: {
            value:
              item?.theme_colors_combinations?.value ||
              singlePageContent?.theme_colors_combinations?.value,
          },
          secondary_theme_colors_combinations: {
            value:
              item?.secondary_theme_colors_combinations?.value ||
              singlePageContent?.secondary_theme_colors_combinations?.value,
          },
          background_color: {
            value:
              item?.background_color?.value ||
              singlePageContent?.background_color?.value,
          },
          same_background_as_page:
            !item?.background_color?.value ||
            (singlePageContent?.background_color?.value || "black") ===
              item?.background_color?.value,
        }
        const colors = getColors(colorData)

        const hasReferences = references?.length > 0
        const caseStudies = hasReferences ? references : null

        return (
          <Component
            key={i}
            data={item}
            content={singlePageContent}
            colors={colors}
            references={caseStudies}
          />
        )
      })}
    </>
  )
}

export default DynamicContent
